import moment from 'moment'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { IActiveTripResponseV2, IRiderTrip } from '../../../types'
import Copy from '../../icons/ui/Copy'
import StatusTag from '../../ui/StatusTag'
import _ from 'lodash'
import Point from 'src/components/icons/ui/Point'
interface PastTripLogsProps {
  pastTrips: IActiveTripResponseV2[]
  cloneTrip: (trip: IRiderTrip) => Promise<any>
}

class PastTripsLogs extends React.Component<PastTripLogsProps> {
  private tripLink: any

  public render() {
    const { pastTrips } = this.props
    const pastTrps = _.groupBy(Object.values(pastTrips), item => {
      return moment(item.createdAt).format('YYYY-MM-DD')
    })
    return (
      <React.Fragment>
        <div className='ptl-container'>
          {Object.values(pastTrps).map((pastTrpsArr, index) => {
            const date = moment(pastTrpsArr[0].createdAt).format('YYYY-MM-DD')
            return (
              <div className={`ptl-trip-item-wrapper ${index !== 0 ? 'pt3' : ''}`} key={date}>
                <p className='bold font-black m0'>{date}</p>
                {pastTrpsArr.map(pastTrip => {
                  const {
                    createdAt,
                    dropoffLocation,
                    id,
                    lastStatus,
                    lastStatusAt,
                    pickupLocation,
                    product,
                    rider,
                    service
                  } = pastTrip
                  const time = moment(createdAt).format('hh:mm')
                  const lastStatusUpdate = moment(lastStatusAt).format('hh:mm')
                  const pickup = pickupLocation.fullAddress.split(',')[0]
                  const dropoff = dropoffLocation.fullAddress.split(',')[0]
                  return (
                    <div
                      className='cursor--pointer pl2 pt02'
                      key={`${id}-${service.serviceId}`}
                      onClick={this.selectTrip}
                    >
                      <div className='flex items-center justify-between'>
                        <Link to={`/trips/${id}`} ref={this.attachRef}>
                          <span className='mt0 mb0 bold font-black'>{service.name}</span>
                          <span className='mt0 mb0 ml1 italic bold font-grey'>{product.name}</span>
                        </Link>
                        &nbsp;
                        <div className='flex items-center'>
                          <StatusTag status={lastStatus} />
                          <Link className='ml2' to={`/trips/create/${rider.riderId}`} onClick={this.copyTrip(pastTrip)}>
                            <Copy className='icon--13x13' />
                          </Link>
                        </div>
                      </div>
                      <div className='flex pt02'>
                        <div className='icon--22x22'>
                          <Point className='icon--22x22 svg-green' />
                        </div>
                        <p className='m0 ptl-item-location pl02'>{pickup}</p>
                      </div>
                      <div className='flex pt02'>
                        <div className='icon--22x22'>
                          <Point className='icon--22x22 svg-red' />
                        </div>
                        <p className='m0 ptl-item-location pl02'>{dropoff}</p>
                      </div>
                      <p className='m0'>Requested: {time}</p>
                      <p className='m0'>Last status update at: {lastStatusUpdate}</p>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </React.Fragment>
    )
  }
  private copyTrip = (trip: IRiderTrip) => (e: any) => {
    this.props.cloneTrip(trip)
  }
  private selectTrip = (e: any) => {
    this.tripLink.handleClick(e)
  }
  private attachRef = (node: any) => {
    this.tripLink = node
  }
}

export default PastTripsLogs



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/PastTripsLogs.tsx